export const onlyNumbersInString = (val) => {          
  return /^[0-9]+$/.test(val)     
}